module.exports = __webpack_public_path__ + "media/images/sport--eisschnellauf-8adfd73938543f5976a7c59f966df1fc.png";